module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("WITH THIS RING")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Reviews & Accolades")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "flourish",
      "src": "images/flourish.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Fast and funny... you won't be able to put down this humorous whodunit.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("~"), _c('i', [_vm._v("Alice Duncan, author of Daisy Gumm Majesty, Mercy Allcutt and Annabelle Blue mysteries")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-239d4be0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section3.vue
// module id = 63
// module chunks = 0